"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_ENDPOINTS = exports.UTIL_ENDPOINTS = exports.API_ENDPOINTS = void 0;
exports.API_ENDPOINTS = {
    vehicle: {
        getAll: `/vehicle`,
        create: `/vehicle`,
        getOne: (id) => `/vehicle/${id}`,
        getOneBySlug: (slug) => `/vehicle/slug/${slug}`,
        getOneByRef: (ref) => `/vehicle/ref/${ref}`,
        getSimilar: (id) => `/vehicle/similar/${id}`,
        deleteOne: (id) => `/vehicle/${id}`,
        updateOne: (id) => `/vehicle/${id}`,
        publishVehicle: (id) => `/vehicle/publish/${id}`,
        unpublishVehicle: (id) => `/vehicle/unpublish/${id}`,
        reserveVehicle: (id) => `/vehicle/reserve/${id}`,
        selfReserveVehicle: (id) => `/vehicle/self-reserve/${id}`,
        markVehicleSold: (id) => `/vehicle/mark-vehicle-sold/${id}`,
        markVehicleDraft: (id) => `/vehicle/mark-vehicle-draft/${id}`,
    },
    vehicleFinance: {
        getAll: `/vehicle-finance`,
        create: `/vehicle-finance`,
        getOne: (id) => `/vehicle-finance/${id}`,
        deleteOne: (id) => `/vehicle-finance/${id}`,
        updateOne: (id) => `/vehicle-finance/${id}`,
    },
    vehicleMake: {
        getAll: `/vehicle/makes`,
        create: `/vehicle/makes`,
        getOne: (id) => `/vehicle/makes/${id}`,
        getOneBySlug: (slug) => `/vehicle/makes/slug/${slug}`,
        deleteOne: (id) => `/vehicle/makes/${id}`,
        updateOne: (id) => `/vehicle/makes/${id}`,
    },
    vehicleFeatures: {
        getAll: `/vehicle/features`,
        create: `/vehicle/features`,
        getOne: (id) => `/vehicle/features/${id}`,
        deleteOne: (id) => `/vehicle/features/${id}`,
        updateOne: (id) => `/vehicle/features/${id}`,
        changeIcon: (id) => `/vehicle/features/${id}/icon`,
    },
    vehicleFeatureCategories: {
        getAll: `/vehicle/feature-categories`,
        create: `/vehicle/feature-categories`,
        getOne: (id) => `/vehicle/feature-categories/${id}`,
        deleteOne: (id) => `/vehicle/feature-categories/${id}`,
        updateOne: (id) => `/vehicle/feature-categories/${id}`,
    },
    vehicleModel: {
        getAll: `/vehicle/models`,
        create: `/vehicle/models`,
        getOne: (id) => `/vehicle/models/${id}`,
        deleteOne: (id) => `/vehicle/models/${id}`,
        updateOne: (id) => `/vehicle/models/${id}`,
    },
    vehicleMeta: {
        getAll: `/vehicle-meta-data`,
        create: `/vehicle-meta-data`,
        getOne: (id) => `/vehicle-meta-data/${id}`,
        deleteOne: (id) => `/vehicle-meta-data/${id}`,
        updateOne: (id) => `/vehicle-meta-data/${id}`,
        aiGenerateTitle: (id) => `/vehicle-meta-data/generate/title/${id}`,
        aiGenerateDescription: (id) => `/vehicle-meta-data/generate/description/${id}`,
        aiGenerateKeyword: (id) => `/vehicle-meta-data/generate/keywords/${id}`,
        aiGenerateVehicleDescription: (id) => `/vehicle-meta-data/generate/vehicle-description/${id}`,
    },
    TestDrive: {
        getAll: `/test-drive-requests`,
        create: `/test-drive-requests`,
        getOne: (id) => `/test-drive-requests/${id}`,
        deleteOne: (id) => `/test-drive-requests/${id}`,
        updateOne: (id) => `/test-drive-requests/${id}`,
    },
    vehicleOrder: {
        getAll: `/vehicle-order`,
        create: `/vehicle-order`,
        getOne: (id) => `/vehicle-order/${id}`,
        deleteOne: (id) => `/vehicle-order/${id}`,
        updateOne: (id) => `/vehicle-order/${id}`,
    },
    vehicleType: {
        getAll: `/vehicle/body-types`,
        create: `/vehicle/body-types`,
        getOne: (id) => `/vehicle/body-types/${id}`,
        deleteOne: (id) => `/vehicle/body-types/${id}`,
        updateOne: (id) => `/vehicle/body-types/${id}`,
    },
    vehicleInspection: {
        getAll: `/vehicle-inspection`,
        create: `/vehicle-inspection`,
        getOne: (id) => `/vehicle-inspection/${id}`,
        deleteOne: (id) => `/vehicle-inspection/${id}`,
        updateOne: (id) => `/vehicle-inspection/${id}`,
    },
    payment: {
        getAll: `/payment`,
        create: `/payment`,
        getOne: (id) => `/payment/${id}`,
        deleteOne: (id) => `/payment/${id}`,
        updateOne: (id) => `/payment/${id}`,
    },
    deposit: {
        getAll: `/deposits`,
        create: `/deposits`,
        getOne: (id) => `/deposits/${id}`,
        deleteOne: (id) => `/deposits/${id}`,
        updateOne: (id) => `/deposits/${id}`,
        initiateRefund: `/deposits/refund/`,
        getOrCreateUserInformation: `/deposits/user-info`,
    },
    leads: {
        getAll: `/leads`,
        create: `/leads`,
        getOne: (id) => `/leads/${id}`,
        deleteOne: (id) => `/leads/${id}`,
        updateOne: (id) => `/leads/${id}`,
    },
    leadPreferences: {
        getAll: `/leads-preferences`,
        create: `/leads-preferences`,
        getOne: (id) => `/leads-preferences/${id}`,
        deleteOne: (id) => `/leads-preferences/${id}`,
        updateOne: (id) => `/leads-preferences/${id}`,
    },
    agents: {
        getAll: `/salesagent`,
        create: `/salesagent`,
        getOne: (id) => `/salesagent/${id}`,
        deleteOne: (id) => `/salesagent/${id}`,
        updateOne: (id) => `/salesagent/${id}`,
    },
    blogs: {
        getAll: `/blog`,
        create: `/blog`,
        getOne: (id) => `/blog/${id}`,
        getOneBySlug: (slug) => `/blog/slug/${slug}`,
        deleteOne: (id) => `/blog/${id}`,
        updateOne: (id) => `/blog/${id}`,
    },
    showroomVisit: {
        getAll: `/showroomvisit`,
        create: `/showroomvisit`,
        getOne: (id) => `/showroomvisit/${id}`,
        deleteOne: (id) => `/showroomvisit/${id}`,
        updateOne: (id) => `/showroomvisit/${id}`,
    },
    sellCarRequest: {
        getAll: `/sell-car-request`,
        create: `/sell-car-request`,
        getOne: (id) => `/sell-car-request/${id}`,
        deleteOne: (id) => `/sell-car-request/${id}`,
        updateOne: (id) => `/sell-car-request/${id}`,
    },
    financeEligibilityRequest: {
        getAll: `/finance-eligibility-request`,
        create: `/finance-eligibility-request`,
        getOne: (id) => `/finance-eligibility-request/${id}`,
        deleteOne: (id) => `/finance-eligibility-request/${id}`,
        updateOne: (id) => `/finance-eligibility-request/${id}`,
        updateStatus: (id) => `/finance-eligibility-request/${id}/status`,
    },
    vehicleReservations: {
        getAll: `/vehicle-reservation`,
        create: `/vehicle-reservation`,
        getOne: (id) => `/vehicle-reservation/${id}`,
        deleteOne: (id) => `/vehicle-reservation/${id}`,
        updateOne: (id) => `/vehicle-reservation/${id}`,
    },
    languages: {
        getAll: `/languages`,
        create: `/languages`,
        getOne: (id) => `/languages/${id}`,
        deleteOne: (id) => `/languages/${id}`,
        updateOne: (id) => `/languages/${id}`,
    },
    user: {
        getAll: `/user`,
        create: `/user`,
        getOne: (id) => `/user/${id}`,
        deleteOne: (id) => `/user/${id}`,
        updateOne: (id) => `/user/${id}`,
        changeProfilePicture: (id) => `/user/${id}/profile-pic`,
        deleteProfilePicture: (id) => `/user/${id}/profile-pic`,
    },
    googleReview: {
        getAll: `/google-reviews`,
        create: `/google-reviews`,
        getOne: (id) => `/google-reviews/${id}`,
        deleteOne: (id) => `/google-reviews/${id}`,
        updateOne: (id) => `/google-reviews/${id}`,
        changeReviewShowPublic: (id) => `/google-reviews/show-public/${id}`,
    },
    tickets: {
        getAll: `/tickets`,
        create: `/tickets`,
        getOne: (id) => `/tickets/${id}`,
        deleteOne: (id) => `/tickets/${id}`,
        updateOne: (id) => `/tickets/${id}`,
        getMyTickets: `/tickets/my`,
        getUserTickets: (userId) => `/tickets/user/${userId}`,
        getAgentTickets: (userId) => `/tickets/agent/${userId}`,
        addMessage: (ticketId) => `/tickets/${ticketId}/messages`,
        addDocument: (ticketId) => `/tickets/${ticketId}/documents`,
        getDocuments: (ticketId) => `/tickets/${ticketId}/documents`,
        reopenTicket: (ticketId) => `/tickets/${ticketId}/reopen`,
    },
    faq: {
        getAll: `/faqs`,
        create: `/faqs`,
        getOne: (id) => `/faqs/${id}`,
        deleteOne: (id) => `/faqs/${id}`,
        updateOne: (id) => `/faqs/${id}`,
    },
    dealDrive: {
        getAll: `/deal-drive`,
        create: `/deal-drive`,
        getOne: (id) => `/deal-drive/${id}`,
        deleteOne: (id) => `/deal-drive/${id}`,
        updateOne: (id) => `/deal-drive/${id}`,
        getAllMakes: (id) => `/deal-drive/brands`,
        getAllModels: (id) => `/deal-drive/models`,
    },
    bankValuationRequest: {
        getAll: `/bank-valuation-request`,
        create: `/bank-valuation-request`,
        getOne: (id) => `/bank-valuation-request/${id}`,
        deleteOne: (id) => `/bank-valuation-request/${id}`,
        updateOne: (id) => `/bank-valuation-request/${id}`,
        estimate: `/bank-valuation-request/estimate`,
    },
    exchangeCarRequest: {
        create: `/exchange-car-request`,
        getAll: `/exchange-car-request/list`,
        getOne: (id) => `/exchange-car-request/${id}`,
        deleteOne: (id) => `/exchange-car-request/${id}`,
        updateOne: (id) => `/exchange-car-request/${id}`,
    },
};
const utilRoutePrefix = "/utils";
exports.UTIL_ENDPOINTS = {
    media: {
        createS3Url: `${utilRoutePrefix}/get-upload-url`,
        preprocessMediaUrl: `${utilRoutePrefix}/process-media`,
        removeS3Media: `${utilRoutePrefix}/remove-s3`,
        removeVehicleMedia: `${utilRoutePrefix}/remove-vehcile-media`,
        removeByIdentifier: `${utilRoutePrefix}/remove-by-identifier`
    },
};
const authRoutePrefix = "/auth";
exports.AUTH_ENDPOINTS = {
    login: `${authRoutePrefix}/login`,
    register: `${authRoutePrefix}/register`,
    refreshAccessToken: `${authRoutePrefix}/refresh-token`,
    sendPhoneVerificationCode: `${authRoutePrefix}/phone/send-verification`,
    verifyPhoneAndLogin: `${authRoutePrefix}/phone/verify-and-login`,
    verifyAnyPhoneNumber: `${authRoutePrefix}/phone/verify`,
    checkPhoneNumberExists: `${authRoutePrefix}/phone/check`,
};
